import React from 'react';

import { SkeletonWrapper } from '@lumapps/a11y/components/SkeletonWrapper';
import { useClassnames } from '@lumapps/classnames';
import { CustomizationComponent, PLACEMENT, Targets } from '@lumapps/customizations/api';
import { ProgressCircular } from '@lumapps/lumx/react';

import { BookmarkType } from '../../types';
import { Bookmark } from './Bookmark';

import './index.scss';

export interface BookmarksProps {
    /** className to be added to the wrapping div */
    className?: string;
    /** The list of bookmarks */
    bookmarksList?: BookmarkType[];
}

const CLASSNAME = 'bookmarks';

/**
 * This component displays the a list of links with their icons.
 */
export const Bookmarks: React.FC<BookmarksProps> = ({ className = '', bookmarksList }) => {
    const { block } = useClassnames(CLASSNAME);

    if (!bookmarksList) {
        return (
            <div className={block('loading', [className])}>
                <SkeletonWrapper>
                    <ProgressCircular />
                </SkeletonWrapper>
            </div>
        );
    }

    return (
        <ul className={block([className])}>
            <CustomizationComponent placement={PLACEMENT.LEFT} target={Targets.BOOKMARKS_ITEMS} />

            {bookmarksList.map((bookmark, key) => (
                // eslint-disable-next-line react/no-array-index-key
                <Bookmark key={key} item={bookmark} />
            ))}

            <CustomizationComponent placement={PLACEMENT.RIGHT} target={Targets.BOOKMARKS_ITEMS} />
        </ul>
    );
};
